import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { compose, mapProps } from 'recompose';
import { withAnalytic } from '@skooldio/analytics-provider/dist/Analytics/hoc';
import styled from 'styled-components';

import { Text, Box, Flex, Icon, ICON_LIST } from 'Components/Base';
import SchoolSummary from 'Containers/SchoolSummary';
import SchoolSummaryExporter from 'Containers/SchoolSummaryExporter';
import { getSchoolCode } from 'Domains/LESchoolData/Routing';
import ButtonOutlinedIcon from 'Components/ButtonOutlinedIcon';
import { useAnalytics } from 'Libs/Analytics';

const getUpdateTime = () => {
  return moment().format('DD/MM/YYYY HH:mm');
};

const SchoolSummaryPageWrapper = styled(Box)`
  border-radius: 10px;
  flex: 1 0;
  display: grid;
  grid: auto auto 1fr / 100%;
  row-gap: 16px;
`;

const SchoolSummaryPage = ({ schoolCode, onLogAction, auth: { myProfile }, ...props }) => {
  const { send } = useAnalytics();
  const { t } = useTranslation('summary');
  const [isFetchData, setIsFetchData] = useState(false);
  const [disabledFetch, setDisabledFetch] = useState(true);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [filterSlot, setFilterSlot] = useState(null);

  const handleFilterApplied = filters => setAppliedFilter(filters);

  return (
    <SchoolSummaryPageWrapper px={[0, null, 2, 7]} py={[0, null, 3, 5]} bg={'white'}>
      <Box>
        <Flex
          alignItems={'center'}
          justifyContent={'space-between'}
          flexWrap={'wrap'}
          style={{ position: 'relative' }}
        >
          <Flex alignItems={'center'} flexWrap={'wrap'} mb={2}>
            <Text.Title>{t('TITLE')}</Text.Title>
            <Box ml={4} ref={setFilterSlot} />
          </Flex>
          <Flex flexShrink={0} mb={2}>
            <SchoolSummaryExporter
              disabled={disabledFetch}
              appliedFilter={appliedFilter}
              schoolCode={schoolCode}
              myProfileId={myProfile.id}
            />
            <ButtonOutlinedIcon
              ml={2}
              lineHeight={'0.5'}
              height={'40px'}
              textProp={{
                fontWeight: 'semibold',
              }}
              leftIcon={<Icon name={ICON_LIST.REFRESH} />}
              message={t('UPDATE')}
              disabled={disabledFetch}
              onClick={() => {
                onLogAction({
                  category: 'Fatch data',
                  action: `Click`,
                  label: `Click on course code page`,
                });
                send('update', { on: 'course_code_page' });
                setIsFetchData(true);
              }}
            />
          </Flex>
        </Flex>
        <Flex justifyContent={'flex-end'} height={'16px'}>
          <Text.Hint
            mt={1}
            color={'timeUpdate'}
            textAlign={'right'}
            display={disabledFetch ? 'none' : 'block'}
          >
            {t('UPDATE_DESCRIPTION_TIME')} {getUpdateTime()}
          </Text.Hint>
        </Flex>
      </Box>

      <SchoolSummary
        isFetchData={isFetchData}
        setIsFetchData={setIsFetchData}
        setDisabledFetch={setDisabledFetch}
        onFilterApplied={handleFilterApplied}
        schoolCode={schoolCode}
        myProfileId={myProfile.id}
        filterSlot={filterSlot}
      />
    </SchoolSummaryPageWrapper>
  );
};

export default compose(mapProps(getSchoolCode), withAnalytic)(SchoolSummaryPage);
